import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import BlogHero from '../components/blog/BlogHero';
import BlogGrid from '../components/blog/BlogGrid';

const BlogPage = () => {
  return (
    <div className="min-h-screen bg-gray-950">
      <Navbar />
      <BlogHero />
      <BlogGrid />
      <Footer />
    </div>
  );
};

export default BlogPage;